import React, {PureComponent} from "react";
import {reduxForm, submit} from "redux-form";
import OrderInfo from "./inc/OrderInfo";
import {userIsGuest} from "../../../../core/helpers/UserHelper";
import {connect} from "react-redux";
import Logout from "../../../../core/components/auth/Logout";
import {Trans, withTranslation} from "react-i18next";
import {scrollToFirstError} from '../../helpers/ScrollToFirstErrorHelper'
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import Payment from "../../../../core/components/order-form/Payment";
import AuthTabs from "../../../../core/components/auth/tabs/AuthTabs";

class OrderFormAuthPage extends PureComponent {

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    submitOrderForm = () => {
        this.props.submit();
    }

    render() {
        const {pristine, submitting, t} = this.props;
        const {user} = this.props;
        const isGuest = userIsGuest(user);

        return <div className="main">
            <h1>{t('Sign in and pay')}</h1>
            <span className="info">{t('Professionals transcribe your files to 99% accuracy')}</span>
            <div className="main-holder inner">
                <div className="content">
                    <div className="block inner">
                        {
                            isGuest ?
                                <AuthTabs
                                    signUpEnabled={true}
                                    loginBtnTitle="LOG IN & CHECKOUT"
                                    registerBtnTitle="REGISTER & CHECKOUT"
                                    children={<Payment/>}
                                    successCallback={this.submitOrderForm}
                                />
                                :
                                <Tabs className="tabs" selectedTabClassName="tabs-active">
                                    <TabList className="tabs-nav">
                                        <Tab>{t('I already have an account')}</Tab>
                                    </TabList>
                                    <TabPanel className="columns">
                                        <Logout/>
                                        <Payment/>
                                        <div className="alignright mobile-hidden">
                                            <button
                                                type="button"
                                                className="btn pink checkout-button"
                                                onClick={this.submitOrderForm}
                                            >
                                                <Trans>CHECKOUT</Trans>
                                            </button>
                                        </div>
                                    </TabPanel>
                                </Tabs>
                        }
                    </div>
                </div>
                <aside id="sidebar">
                    <OrderInfo/>
                    <div className="alignright mobile-visible">
                        <button
                            type="button"
                            className="btn pink checkout-button"
                            disabled={pristine || submitting}
                            onClick={this.submitOrderForm}
                        >
                            {t('CHECKOUT')}
                        </button>
                    </div>
                </aside>
            </div>
        </div>
    }
}

OrderFormAuthPage = withTranslation()(OrderFormAuthPage);

OrderFormAuthPage = reduxForm({
    form: 'OrderForm',
    destroyOnUnmount: false, // <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    onSubmitFail: (errors) => scrollToFirstError(errors),
})(OrderFormAuthPage)

export default connect(
    state => ({
        user: state.user,
    }),
    dispatch => ({
        submit: formName => dispatch(submit(formName)),
    })
)(OrderFormAuthPage);